
export function convertDate(date) {
    let year = date.getFullYear();
    let _month = Number(date.getMonth())+1;
    let month = _month < 10 ? `0${_month}` : _month;
    let _day = date.getDate();
    let day = _day < 10 ? `0${_day}`:_day;
    return `${year}-${month}-${day}`;
}
export function deConvertDate(date) {
    if(date == null) return null;
    let dates = date.split('-');
    return new Date(Number(dates[0]), Number(dates[1]) - 1, Number(dates[2]));
}
